import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import http from './http'
import lineClamp from 'vue-line-clamp'
import Loader from '@/components/loader.vue'

Vue.use(lineClamp)

Vue.config.productionTip = false

Vue.component('loader', Loader)

Vue.filter('separator', value => {
    return value != 'Infinity' ? Math.round(value ? value : 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : 0
})

Vue.filter('percentage', value => {
    return value != 'Infinity' ? Math.round(value * 100) + '%' : 0
})
Vue.filter('percentageDecimal', value => {
    return value != 'Infinity' ? (Math.round(value * 10000) / 100) + '%' : 0
})

Vue.filter('nameFilter', value => {
    if (value.match(/Alka_AG_Mersalg_/)) return value.substring(16) 
    else if (value.match(/Alka_AG_/)) return value.substring(8)
    else return value
})

Vue.filter('duration', value => {
    const hours = Math.floor(value / 3600).toString()
    const minutes = Math.floor((value % 3600) / 60).toString()
    const seconds = Math.floor((value % 3600) % 60).toString()
    const h = hours.length > 1 ? hours : '0' + hours
    const m = minutes.length > 1 ? minutes : '0' + minutes
    const s = seconds.length > 1 ? seconds : '0' + seconds
    return h + ':' + m + ':' + s
})

Vue.filter('timestamp', value => {
    if (value > 3600) {
        const hours = Math.floor(value / 3600).toString()
        const minutes = Math.floor((value % 3600) / 60).toString()
        const seconds = Math.floor((value % 3600) % 60).toString()
        const h = hours.length > 1 ? hours : '0' + hours
        const m = minutes.length > 1 ? minutes : '0' + minutes
        const s = seconds.length > 1 ? seconds : '0' + seconds
        return h + ':' + m + ':' + s
    } else {
        const minutes = Math.floor(value / 60).toString()
        const seconds = Math.floor((value % 3600) % 60).toString()
        const m = minutes.length > 1 ? minutes : '0' + minutes
        const s = seconds.length > 1 ? seconds : '0' + seconds
        return m + ':' + s
    }
})

Vue.filter('name', name => {
    let namesArray = name.split(' ')
    return namesArray[0] + ' ' + namesArray[namesArray.length - 1]
})

function buildObject (keys) {
    let emptyObject = {}
    keys.forEach(key => {
        emptyObject[key] = 0
    })
    return emptyObject
}

function reduceNested (object, keys) {
    let initialObject = buildObject(keys)
    if (!object) return initialObject
    return Object.keys(object).reduce((sumObj, key) => {
        if (typeof object[key] !== 'object') {
            sumObj[key] += object[key]
        } else {
            let temp = reduceNested(object[key], keys)
            keys.forEach(key => {
                sumObj[key] += temp[key]
            })
        }
        return sumObj
    }, initialObject)
}

function hbLeadLink (leadUniqueId) {
    return `https://hero01.herobase.com/NewItem/WebClient.aspx?id=${leadUniqueId.slice(0, -5)}&mode=edit&arguments={}`
}

Vue.prototype.$http = http
Vue.prototype.$reduceNested = reduceNested
Vue.prototype.$hbLeadLink = hbLeadLink

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')